// Library Imports
import { QueryClient } from "@tanstack/react-query";

// Instantiate a shared QueryClient for the app
export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      retry: 1,
      refetchOnWindowFocus: false,
    },
    mutations: {
      retry: 0,
    },
  },
});